import AttachmentFilter from './AttachmentFilter';

const Attachments = {
  Filter: AttachmentFilter
};

export default Attachments;
